import { LocalComponent } from "~/ecs/base"

export class MorphApplied extends LocalComponent {}
